import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AdalService } from './adal.service'
import { GlobalService } from '../services/global.service';
import { UserModel } from '../models/user.model';

@Injectable()
export class AuthGuardService implements CanActivate {
    user: UserModel = new UserModel();

    constructor(
        private router: Router,
        private globals: GlobalService,
        private adalSrv:AdalService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.globals.isConnected) { //{No internet connection
            console.log('AuthGuard: Not connected');
            return true;
        }

        if(localStorage.getItem('overrideInstallRequirement')){
            this.globals.overrideInstallRequirement = localStorage.getItem('overrideInstallRequirement') == new Date().toDateString();
        }

        if ((state.url == "/?i=" || (!this.globals.isInstalled && this.globals.isiOS)) && (!this.globals.overrideInstallRequirement)) {
            //////////////////////////////////////////////////////////////////////////////////////
            //is iOS but is not installed....    
            //////////////////////////////////////////////////////////////////////////////////////            
            this.router.navigate(['/installpage'], { skipLocationChange: true });
            return false;
        } else if (this.adalSrv.isLogged) {
            console.log('AuthGuard: true');
            return true; 
        } else {
            this.user = new UserModel();
            this.globals.SetUser(this.user);
            localStorage.setItem('returnUrl', state.url);
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        console.log("AUTH: AuthGuard-canActivateChild");
        return this.canActivate(childRoute, state);
    }

    // intercept(req: HttpRequest<any>, next: HttpHandler):  Observable<HttpEvent<any>> {
    //     var subscription = this.adalSrv.subscription;
    //     return this.adalSrv.acquireToken(this.adalSrv.resourceEndpoint)
    //     .switchMap(function (token) {
    //         return next.handle(req.clone({setHeaders: {Authorization: `Bearer ${token}`,
    //             "withCredentials": "true",      
    //             "Content-Type": "application/json; charset=utf-8",
    //             "Ocp-Apim-Subscription-Key": subscription}})); 

    //     });
    // }
}
